<template>
  <div @click="download">
    <i class="el-icon-upload2" />
    {{ $t('CampaignForm_Button_ExportContent') }}
  </div>
</template>

<script>
import { fields as exportFields } from '@/modules/campaign-manage/enum/ImportExportFields'
import _ from 'lodash'
import { channelTypes } from '@/modules/campaign-manage/enum/Labels'
import { onsiteTypes } from '@/modules/campaign-manage/enum/OnsiteTypesEnum'
export default {
  name: 'ExportContentButton',
  props: {
    channel: {
      type: Number,
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    type: {
      type: [Number, String],
      required: false,
      default: 'default'
    }
  },
  data() {
    return {
      exportFields
    }
  },
  computed: {
    fileName() {
      let variant =
        this.$route.query.variant !== 'default'
          ? `_${this.$route.query.variant}`
          : ''
      let lang =
        this.$route.query.lang !== 'default'
          ? `_${this.$route.query.lang}`
          : '_en'
      let id = this.$route.query.id ? `_${this.$route.query.id}` : ''
      return `${this.$route.query.channel}${variant}${lang}${id}.json`
    }
  },
  methods: {
    download() {
      let data = {}
      let fields = _.get(this.exportFields, `${this.channel}.${this.type}`, [])

      fields.forEach(field => {
        let value = _.get(this.value, field, '')
        if (this.channel === channelTypes.email && field === 'email_template') {
          value = JSON.parse(value)
        }

        if (
          this.channel === channelTypes.onsite &&
          this.value.onsite_type === onsiteTypes.POPUP
        ) {
          value = this.preparePopupParams(field, value)
        }
        _.set(data, field, value)
      })

      // wrap channels in channel specific key (exclude channels that are already wrapped: inapp, onsite popup)
      if (this.value.onsite_type === onsiteTypes.ALERT) {
        data = { [this.$route.query.channel]: { alert: data } }
      } else if (
        this.channel !== channelTypes.onsite &&
        this.channel !== channelTypes.inapp
      ) {
        data = { [this.$route.query.channel]: data }
      }

      const href = new Blob([JSON.stringify(data, null, 2)], {
        type: 'application/json'
      })
      let link = document.createElement('a')
      link.download = this.fileName
      link.href = URL.createObjectURL(href)
      link.click()
      URL.revokeObjectURL(link.href)
    },

    preparePopupParams(field, value) {
      if (
        field === 'onsite.popup.button0.text' &&
        !this.value.onsite.popup.button0.enabled
      ) {
        value = ''
      }

      if (
        field === 'onsite.popup.button1.text' &&
        !this.value.onsite.popup.button1.enabled
      ) {
        value = ''
      }

      if (
        field === 'onsite.popup.title' &&
        !this.value.onsite.popup.title_checkbox
      ) {
        value = ''
      }

      if (
        field === 'onsite.popup.main_text' &&
        !this.value.onsite.popup.text_checkbox
      ) {
        value = ''
      }

      if (
        field === 'onsite.popup.footer' &&
        !this.value.onsite.popup.footer_checkbox
      ) {
        value = ''
      }

      return value
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/ExportContentButton.vue